module.exports = __webpack_public_path__ + "static/media/messengerLogo.4f1cec77.png";